export enum BreadcrumbTypeEnum {
    ATTRACTION = 'ATTRACTION',
    EXPOSE_LABEL = 'EXPOSE_LABEL',
    HOME = 'HOME',
    OFFER = 'OFFER',
    PROPERTY_TYPE = 'PROPERTY_TYPE',
    REGION = 'REGION',
    TOPIC = 'TOPIC',
}
